
import { CustomFavoriteNameDialogComponent } from './custom-favorite-name-dialog.component';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [CustomFavoriteNameDialogComponent],
  imports: [
    MatButtonModule,
    MatDialogModule,
    MatInputModule,
    FormsModule
  ],
  exports: [
    CustomFavoriteNameDialogComponent
  ]
})
export class CustomFavoriteNameDialogModule { }
